function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import { isObject } from '@finect/front-utils/isObject';
export var getCategoryByProvider = function getCategoryByProvider(categories, provider) {
  return categories.find(function (element) {
    return element.provider === provider;
  });
};
export var getCategoriesByProvider = function getCategoriesByProvider(categories, provider) {
  return categories.filter(function (element) {
    return element.provider === provider;
  });
};
export var getFundMainClass = function getFundMainClass(fund) {
  return _typeof(fund.class) === 'object' ? fund.classes.find(function (item) {
    return item.id === fund.class.id;
  }) : fund.classes.find(function (item) {
    return item.id === fund.id;
  });
};
export var getFundClass = function getFundClass(fund) {
  var mainClass = getFundMainClass(fund);
  return mainClass ? mainClass : _typeof(fund.class) === 'object' ? fund.class : {
    id: fund.id,
    name: fund.name
  };
};
export var getFundClassName = function getFundClassName(fund) {
  return fund.class ? fund.class.name : fund.name;
};
export var getFundDisplayName = function getFundDisplayName(fund, productType) {
  return productType.id === 'plan' ? getFundClassName(fund) : fund.name;
};
export var getPeriodsPerformance = function getPeriodsPerformance(periods, periodCode, periodType) {
  if (['M0', 'M60'].includes(periodCode)) {
    var _periodData = periods.find(function (item) {
      return item.type === periodType && item.period === periodCode;
    });
    if (periodCode === 'M0' && _periodData && !_periodData.date.startsWith(new Date().getFullYear())) {
      return _objectSpread(_objectSpread({}, _periodData), {}, {
        value: '-'
      });
    }
    return _periodData || {
      period: periodCode,
      type: periodType,
      value: '-'
    };
  }
  var periodData = periods.find(function (item) {
    return item.type === periodType && item.period === periodCode;
  });
  return periodData ? periodData : null;
};
export var getPeriodPerformance = function getPeriodPerformance(stats, periodCode, periodType) {
  return getPeriodsPerformance(stats.performance.periods, periodCode, periodType);
};
export var getQuarterPerformance = function getQuarterPerformance(stats, year) {
  var period = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'M12';
  var quarterData = stats.performance.quarters.find(function (item) {
    return item.year === Number(year) && item.period === period;
  });
  return quarterData ? quarterData : null;
};
export var getYearlyPerformance = function getYearlyPerformance(stats, year) {
  return getQuarterPerformance(stats, year, 'M12');
};
export var getStandardDeviation = function getStandardDeviation(stats, periodCode) {
  var periodData = stats.standardDeviation.find(function (item) {
    return item.period === periodCode;
  });
  return periodData ? periodData : null;
};
export var getPeriodStat = function getPeriodStat(stats, periodCode, stat) {
  var periodData = stats[stat].find(function (item) {
    return item.period === periodCode;
  });
  return periodData ? periodData : null;
};
export var getClassClean = function getClassClean(fund) {
  var commercializations = fund.commercializations;
  return commercializations.filter(function (_ref) {
    var relationship = _ref.relationship;
    return relationship === 'distributor';
  }).find(function (_ref2) {
    var security = _ref2.security;
    return security.id === fund.class.id && security.clean;
  });
};
export var getOrderCommercializations = function getOrderCommercializations(commercializations) {
  var orderType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'alpha';
  if (orderType === 'alpha') {
    commercializations.sort(function (a, b) {
      if (a.organization.displayName > b.organization.displayName) {
        return 1;
      }
      if (a.organization.displayName < b.organization.displayName) {
        return -1;
      }
      return 0;
    });
  }
  return commercializations;
};
export var getClassesWithCommercializations = function getClassesWithCommercializations(fund) {
  var classes = fund.classes,
    commercializations = fund.commercializations;
  var newClasses = classes.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      commercializations: getOrderCommercializations(commercializations.filter(function (elem) {
        return elem.relationship === 'distributor' && elem.security.id === item.id;
      }))
    });
  });
  return newClasses;
};
export var getFundClassFee = function getFundClassFee(entity, feeCode) {
  var feeCodeId = feeCode.toLowerCase();
  var fundClass = getFundMainClass(entity);
  if (!fundClass) {
    return null;
  }
  var fees = fundClass.fees;
  if (!fees) {
    return null;
  }
  if (isObject(fees)) {
    return fees.hasOwnProperty(feeCodeId) ? fees[feeCodeId] : null;
  }
  if (Array.isArray(fees)) {
    return fees.find(function (_ref3) {
      var type = _ref3.type;
      return type.toLowerCase() === feeCodeId;
    });
  }
  return null;
};